/**
 * Token storage key
 */
const TOKEN_KEY = 'authToken';

/**
 * Token data structure
 */
interface TokenData {
    token: string;
    expireTime?: number;
    autoLogin?: boolean;
}

/**
 * Save token based on autoLogin setting
 */
export function saveToken(token: string, autoLogin: boolean, expireTime?: number): void {
    const tokenData: TokenData = {
        token,
        expireTime,
        autoLogin,
    };

    if (autoLogin) {
        localStorage.setItem(TOKEN_KEY, JSON.stringify(tokenData));
        sessionStorage.removeItem(TOKEN_KEY);
    } else {
        sessionStorage.setItem(TOKEN_KEY, JSON.stringify(tokenData));
        localStorage.removeItem(TOKEN_KEY);
    }
}

/**
 * Get token from storage
 */
export function getToken(): string | null {
    const localData = localStorage.getItem(TOKEN_KEY);
    if (localData) {
        try {
            const tokenData: TokenData = JSON.parse(localData);
            if (tokenData.expireTime && Date.now() > tokenData.expireTime) {
                clearToken();
                return null;
            }
            return tokenData.token;
        } catch {
            localStorage.removeItem(TOKEN_KEY);
        }
    }

    const sessionData = sessionStorage.getItem(TOKEN_KEY);
    if (sessionData) {
        try {
            const tokenData: TokenData = JSON.parse(sessionData);
            if (tokenData.expireTime && Date.now() > tokenData.expireTime) {
                clearToken();
                return null;
            }
            return tokenData.token;
        } catch {
            sessionStorage.removeItem(TOKEN_KEY);
        }
    }

    return null;
}

/**
 * Clear token from both storage types
 */
export function clearToken(): void {
    localStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(TOKEN_KEY);
}

/**
 * Check if user is authenticated
 */
export function isAuthenticated(): boolean {
    return !!getToken();
}
